import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessageDialogComponent } from '../components/ui-components/message-dialog/message-dialog.component';

@Injectable()
export class CanDeactivateService {
  private formChanged: boolean;

  constructor(private readonly matDialog: MatDialog) {
  }

  canDeactivate(): Observable<boolean> {
    if (this.formChanged) {
      return this.showFormsChangeDialog('You are about to navigate away from enrichment settings and will lose all changes. Do you want to continue?');
    }
    return of(true);
  }

  setIsFormChanged(flag: boolean): void {
    this.formChanged = flag;
  }

  isFormChanged(): boolean {
    return this.formChanged;
  }

  showFormsChangeDialog(message: string): Observable<boolean> {
    const config: MatDialogConfig = {
      panelClass: ['modal-md'],
      data: { message }
    };
    return this.matDialog.open(MessageDialogComponent, config).afterClosed();
  }
}
